export const ActionTypes = {
	CHANNEL_REPORT_OPTIONS_GET: 'CHANNEL_REPORT_OPTIONS_GET',
	CHANNEL_REPORT_GET: 'CHANNEL_REPORT_GET',
	CHANNEL_REPORT_PERIOD_SELECT: 'CHANNEL_REPORT_PERIOD_SELECT',
	FEATURES_GET: 'FEATURES_GET'
};
